export const prettierrcCode = () => {
  let code = `{
  "tabWidth": 4,
  "useTabs": true,
  "singleQuote": true,
  "trailingComma": "es5",
  "bracketSpacing": true,
  "parenSpacing": true,
  "jsxBracketSameLine": false,
  "semi": true,
  "arrowParens": "always",
  "printWidth": 80
}
`;

  return code;
};
